module.exports = __webpack_public_path__ + "img/voice.6d0413c2.svg";